/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { SectionRowElementTableColumn } from 'templates/pubSub/types/TemplateType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import { usePubSubNode, usePubSubValue } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';

interface ISectionElementContentTableCellProps {
  templateContext: TemplateContext;
  column: SectionRowElementTableColumn;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementContentTableCell(props: ISectionElementContentTableCellProps): ReactElement {
  const valueFilters = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.column.valueVariable?.variablePath,
  );
  const valueNode = usePubSubNode(valueFilters, props.startingNodeId);
  const value = usePubSubValue(valueNode);

  let unitSymbol: string | undefined;
  const unitFilters = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.column.valueVariable?.hasUnit ? props.column.valueVariable?.variablePath + '.EngineeringUnits' : undefined,
  );
  const unitNode = usePubSubNode(unitFilters, props.startingNodeId);
  const unitValue = usePubSubValue(unitNode);
  if (unitValue) {
    unitSymbol = unitValue.DisplayName;
  }

  const displayValue = TemplateHelperPubSub.formatVariableValue(value, props.column.valueVariable, unitSymbol);

  if (
    TemplateHelperPubSub.shouldHideOptionalVariable(
      value,
      props.column.valueVariable,
      `SectionElementContentTableCell:${props.column.id}`,
    )
  ) {
    return <td />;
  }

  return <td>{displayValue}</td>;
}
